import React from 'react';

const GettingStartedPage = () =>
  <div>
    <h1>Getting Started</h1>
  </div>

export default GettingStartedPage;



// WEBPACK FOOTER //
// ./src/components/admin/GettingStarted.jsx